import styled from 'styled-components';

const Wrapper = styled.div`
  .searchlist {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #dbdbdbff;

    &__input {
      background-color: white;
      border: none;
      border-bottom: 1px solid #dbdbdbff;
      padding: 0 12px 15px 0;
    }

    &__items {
      display: flex;
      flex-direction: column;
      gap: 12px;
      min-height: 140px;
      max-height: 140px;
      overflow-y: auto;

      &__item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 12px;

        &__left {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        &__input {
          -webkit-appearance: radio;
          cursor: pointer;
        }

        &__label {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex: 1;
          cursor: pointer;
        }

        &__count {
          margin: 0;
        }
      }
    }

    &__noresult {
      margin: 0;
    }
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/SearchableList/style.js